export enum DetailLevel {
  Brief = 'brief',
  Balanced = 'balanced',
  Detailed = 'detailed',
  Comprehensive = 'comprehensive',
}

export enum FormatMode {
  Structured = 'structured',
  Hybrid = 'hybrid',
  Prose = 'prose',
}

export enum AbbreviationPolicy {
  Minimal = 'minimal',
  Balanced = 'balanced',
  Liberal = 'liberal',
}

export enum QuotationPolicy {
  None = 'none',
  SalientOnly = 'salient_only',
  Liberal = 'liberal',
}

export enum EmptySectionPolicy {
  LeaveBlank = 'leave_blank',
  Omit = 'omit',
}

export enum ClinicianReference {
  FirstPerson = 'first_person',
  Passive = 'passive',
  ThirdPerson = 'third_person',
}

export enum PatientReference {
  NameIfAvailableElseThey = 'name_if_available_else_they',
  NameOnly = 'name_only',
  They = 'they',
}

export const DETAIL_LEVELS: Array<DetailLevel> = [
  DetailLevel.Brief,
  DetailLevel.Balanced,
  DetailLevel.Detailed,
  DetailLevel.Comprehensive,
];

export const FORMAT_MODES: Array<FormatMode> = [
  FormatMode.Structured,
  FormatMode.Hybrid,
  FormatMode.Prose,
];

export const ABBREVIATION_POLICIES: Array<AbbreviationPolicy> = [
  AbbreviationPolicy.Minimal,
  AbbreviationPolicy.Balanced,
  AbbreviationPolicy.Liberal,
];

export const QUOTATION_POLICIES: Array<QuotationPolicy> = [
  QuotationPolicy.None,
  QuotationPolicy.SalientOnly,
  QuotationPolicy.Liberal,
];

export const EMPTY_SECTION_POLICIES: Array<EmptySectionPolicy> = [
  EmptySectionPolicy.LeaveBlank,
  EmptySectionPolicy.Omit,
];

export const CLINICIAN_REFERENCES: Array<ClinicianReference> = [
  ClinicianReference.FirstPerson,
  ClinicianReference.Passive,
  ClinicianReference.ThirdPerson,
];

export const PATIENT_REFERENCES: Array<PatientReference> = [
  PatientReference.NameIfAvailableElseThey,
  PatientReference.NameOnly,
  PatientReference.They,
];

export interface NoteGenerationSettings {
  detailLevel: DetailLevel;
  formatMode: FormatMode;
  abbreviationPolicy: AbbreviationPolicy;
  quotationPolicy: QuotationPolicy;
  emptySectionPolicy: EmptySectionPolicy;
  referClinicianAs: ClinicianReference;
  referPatientAs: PatientReference;
}
